import script from "./ScientificScopes.vue?vue&type=script&setup=true&lang=js"
export * from "./ScientificScopes.vue?vue&type=script&setup=true&lang=js"

import "./ScientificScopes.vue?vue&type=style&index=0&id=9b5657e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b5657e8"]])

export default __exports__